import { render, staticRenderFns } from "./RedeemedCouponsTable.vue?vue&type=template&id=6f6fa8b4&"
import script from "./RedeemedCouponsTable.vue?vue&type=script&lang=js&"
export * from "./RedeemedCouponsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports